export const categories = [
  {
    slug: "chaopen-yuanli",
    name: "潮喷原理",
    description: "科学解析女性潮喷的生理机制与成因",
    icon: "ri-drop-fill",
    articleCount: 12,
  },
  {
    slug: "ziwei-jiqiao",
    name: "自慰技巧",
    description: "安全有效的自慰方法与潮喷触发技巧",
    icon: "ri-heart-pulse-fill",
    articleCount: 15,
  },
  {
    slug: "gaochao-leixing",
    name: "高潮类型",
    description: "认识不同类型的女性高潮体验",
    icon: "ri-star-fill",
    articleCount: 10,
  },
  {
    slug: "xingjiankang-kepu",
    name: "性健康科普",
    description: "女性生理健康知识与常见误区澄清",
    icon: "ri-shield-check-fill",
    articleCount: 18,
  },
  {
    slug: "shenti-renzhi",
    name: "身体认知",
    description: "了解自己的身体，建立积极的性观念",
    icon: "ri-mental-health-fill",
    articleCount: 8,
  },
  {
    slug: "zhuyi-shixiang",
    name: "注意事项",
    description: "自慰与潮喷过程中的安全与卫生须知",
    icon: "ri-alert-fill",
    articleCount: 6,
  },
];

export const allArticles = [
  {
    slug: "chaopen-shengli-yuanli",
    title: "潮喷的生理原理：科学解读女性喷水现象",
    excerpt: "潮喷（喷水）是女性在高潮时从尿道排出液体的生理现象。本文从解剖学、生理学角度全面解析潮喷的形成机制，包括斯基恩氏腺（女性前列腺）的作用、液体成分分析以及神经反射通路，帮助你科学理解这一正常的身体反应。",
    category: "chaopen-yuanli",
    image: "https://readdy.ai/api/search-image?query=Soft%20warm%20minimalist%20abstract%20illustration%20of%20female%20body%20anatomy%20with%20flowing%20water%20elements%2C%20gentle%20coral%20and%20cream%20tones%2C%20scientific%20yet%20artistic%20style%2C%20clean%20background%2C%20comforting%20and%20educational%20vibe&width=800&height=500&seq=article-physiology-01&orientation=landscape",
    readTime: "8 分钟",
    date: "2026-07-20",
    featured: true,
  },
  {
    slug: "chaopen-shi-shenme-ganjue",
    title: "潮喷是什么感觉？真实体验与科学解释",
    excerpt: "很多女性好奇潮喷到底是一种什么感觉。本文结合生理学知识和真实反馈，详细描述潮喷发生前后的身体感受变化，包括前兆信号、过程中的体感特征以及事后的身心状态，帮助你建立合理的预期。",
    category: "chaopen-yuanli",
    image: "https://readdy.ai/api/search-image?query=Abstract%20soft%20watercolor%20style%20illustration%20of%20gentle%20waves%20and%20flowing%20water%2C%20warm%20peach%20and%20cream%20tones%2C%20calm%20and%20peaceful%20atmosphere%2C%20feminine%20energy%2C%20clean%20minimal%20background%2C%20artistic%20and%20elegant&width=800&height=500&seq=article-feeling-01&orientation=landscape",
    readTime: "6 分钟",
    date: "2026-07-15",
    featured: true,
  },
  {
    slug: "ziwei-chufa-chaopen-jiqiao",
    title: "自慰中触发潮喷的实用技巧与方法",
    excerpt: "想要在自慰中体验潮喷？本文分享经过验证的安全技巧和方法，包括G点刺激手法、呼吸配合、盆底肌训练以及心理放松策略。循序渐进地引导你探索身体，在安全舒适的环境中尝试潮喷体验。",
    category: "ziwei-jiqiao",
    image: "https://readdy.ai/api/search-image?query=Abstract%20gentle%20curves%20and%20flowing%20lines%20in%20warm%20coral%20and%20cream%20palette%2C%20soft%20organic%20shapes%2C%20peaceful%20meditation%20like%20atmosphere%2C%20minimalist%20art%20style%2C%20calm%20and%20safe%20feeling&width=800&height=500&seq=article-technique-01&orientation=landscape",
    readTime: "10 分钟",
    date: "2026-07-10",
    featured: true,
  },
  {
    slug: "pen-diji-xunlian-fangfa",
    title: "盆底肌训练：增强潮喷体验的关键",
    excerpt: "强健的盆底肌是提升潮喷体验的重要因素。本文介绍科学有效的盆底肌训练方法（凯格尔运动），包括正确的肌肉识别技巧、训练频率与强度安排，以及如何在自慰中结合盆底肌控制来增强快感和促进潮喷发生。",
    category: "ziwei-jiqiao",
    image: "https://readdy.ai/api/search-image?query=Abstract%20minimalist%20illustration%20of%20gentle%20body%20movement%20and%20flow%2C%20warm%20peach%20and%20beige%20tones%2C%20soft%20organic%20shapes%2C%20yoga%20inspired%20aesthetic%2C%20clean%20and%20calm%20background&width=800&height=500&seq=article-pelvic-01&orientation=landscape",
    readTime: "7 分钟",
    date: "2026-07-05",
    featured: false,
  },
  {
    slug: "yindao-gaochao-yin-di-gaochao",
    title: "阴道高潮与阴蒂高潮：区别与联系",
    excerpt: "女性高潮并非只有一种形式。本文详细对比阴道高潮和阴蒂高潮的生理机制、感受差异以及触发方式，帮助你全面了解自己的身体反应模式，找到最适合自己的愉悦方式。",
    category: "gaochao-leixing",
    image: "https://readdy.ai/api/search-image?query=Abstract%20soft%20flowing%20waves%20and%20gentle%20curves%20illustration%2C%20warm%20rose%20and%20cream%20color%20palette%2C%20elegant%20feminine%20energy%2C%20minimalist%20artistic%20style%2C%20clean%20background%2C%20calm%20and%20beautiful&width=800&height=500&seq=article-orgasm-01&orientation=landscape",
    readTime: "9 分钟",
    date: "2026-06-28",
    featured: false,
  },
  {
    slug: "hunhe-gaochao-shi-shenme",
    title: "混合高潮是什么？多重高潮的可能性",
    excerpt: "混合高潮是指同时或连续经历多种类型的高潮。本文探讨混合高潮的生理基础、实现条件和体验特征，让你了解女性身体在高潮体验上的丰富可能性，以及如何通过练习来扩展自己的愉悦边界。",
    category: "gaochao-leixing",
    image: "https://readdy.ai/api/search-image?query=Abstract%20layered%20waves%20and%20soft%20overlapping%20shapes%20in%20warm%20coral%20and%20beige%20tones%2C%20gentle%20flowing%20movement%2C%20harmonious%20composition%2C%20minimalist%20art%2C%20calm%20and%20elegant%20atmosphere&width=800&height=500&seq=article-blended-01&orientation=landscape",
    readTime: "8 分钟",
    date: "2026-06-20",
    featured: false,
  },
  {
    slug: "nvxing-xingchongdong-shengli",
    title: "女性性冲动的生理机制：从欲望到高潮",
    excerpt: "了解女性性反应的完整周期是认识自我的重要一步。本文系统讲解女性性冲动的生理机制，从大脑的性兴奋中枢激活到外周血管充血反应，再到高潮时的神经肌肉反射，构建完整的科学认知框架。",
    category: "xingjiankang-kepu",
    image: "https://readdy.ai/api/search-image?query=Abstract%20scientific%20illustration%20of%20flowing%20energy%20and%20brain%20waves%2C%20warm%20coral%20and%20cream%20palette%2C%20soft%20organic%20shapes%2C%20minimalist%20style%2C%20educational%20yet%20artistic%20vibe&width=800&height=500&seq=article-science-01&orientation=landscape",
    readTime: "11 分钟",
    date: "2026-06-15",
    featured: false,
  },
  {
    slug: "ziwei-changjian-wuqu",
    title: "女性自慰的常见误区与科学真相",
    excerpt: "关于女性自慰，社会上流传着各种误解和偏见。本文逐一澄清最常见的误区，包括「自慰会影响健康吗」「自慰会降低敏感度吗」「有伴侣还需要自慰吗」等问题，用科学证据帮助你建立正确的认知。",
    category: "xingjiankang-kepu",
    image: "https://readdy.ai/api/search-image?query=Abstract%20illustration%20of%20question%20marks%20dissolving%20into%20soft%20flowing%20shapes%2C%20warm%20peach%20and%20cream%20tones%2C%20gentle%20and%20reassuring%20atmosphere%2C%20minimalist%20art%20style%2C%20clean%20background&width=800&height=500&seq=article-myths-01&orientation=landscape",
    readTime: "7 分钟",
    date: "2026-06-10",
    featured: false,
  },
  {
    slug: "nvxing-shengzhi-jiepou-jichu",
    title: "女性生殖解剖基础：认识你的身体",
    excerpt: "了解自己的身体结构是性健康的第一步。本文以通俗易懂的语言介绍女性外生殖器和内生殖器的解剖结构，包括阴蒂、G点、斯基恩氏腺等与性快感密切相关的部位，帮助你建立正确的身体认知。",
    category: "shenti-renzhi",
    image: "https://readdy.ai/api/search-image?query=Abstract%20organic%20shapes%20and%20gentle%20curves%20inspired%20by%20nature%2C%20warm%20coral%20and%20cream%20palette%2C%20soft%20flowing%20lines%2C%20minimalist%20educational%20illustration%2C%20clean%20background&width=800&height=500&seq=article-anatomy-01&orientation=landscape",
    readTime: "9 分钟",
    date: "2026-06-05",
    featured: false,
  },
  {
    slug: "ziwei-weisheng-anquan",
    title: "自慰与潮喷的卫生安全注意事项",
    excerpt: "安全和卫生是自慰过程中不可忽视的重要环节。本文详细介绍自慰前后的清洁步骤、工具卫生管理、潮喷时的防护措施以及需要警惕的异常信号，确保你在探索身体的同时保护好自己的健康。",
    category: "zhuyi-shixiang",
    image: "https://readdy.ai/api/search-image?query=Abstract%20soft%20protective%20shapes%20and%20gentle%20barriers%20illustration%2C%20warm%20coral%20and%20cream%20tones%2C%20calm%20and%20safe%20atmosphere%2C%20minimalist%20style%2C%20clean%20background&width=800&height=500&seq=article-safety-01&orientation=landscape",
    readTime: "6 分钟",
    date: "2026-05-28",
    featured: false,
  },
  {
    slug: "shenti-xinhao-renzhi",
    title: "学会倾听身体信号：建立与自己的连接",
    excerpt: "很多女性与自己的身体缺乏深度连接。本文引导你学会感知和解读身体发出的各种信号，包括兴奋信号、不适信号和即将高潮的前兆信号，帮助你建立更敏锐的身体觉察能力，提升自慰体验的质量。",
    category: "shenti-renzhi",
    image: "https://readdy.ai/api/search-image?query=Abstract%20gentle%20flowing%20lines%20representing%20body%20awareness%20and%20connection%2C%20warm%20peach%20and%20beige%20tones%2C%20soft%20meditative%20atmosphere%2C%20minimalist%20art%2C%20clean%20background&width=800&height=500&seq=article-body-01&orientation=landscape",
    readTime: "8 分钟",
    date: "2026-05-20",
    featured: false,
  },
  {
    slug: "qingshuiji-yundong-zhunbei",
    title: "潮喷前的准备：环境、工具与心理调适",
    excerpt: "良好的准备是成功体验潮喷的基础。本文从环境布置、必要工具选择到心理调适方法，全面介绍潮喷前的准备工作，帮助你创造一个安全、舒适、放松的空间，为美好的自慰体验打下基础。",
    category: "zhuyi-shixiang",
    image: "https://readdy.ai/api/search-image?query=Abstract%20cozy%20and%20safe%20space%20with%20soft%20flowing%20shapes%2C%20warm%20coral%20and%20cream%20tones%2C%20peaceful%20atmosphere%2C%20minimalist%20style%2C%20clean%20background%2C%20comforting%20vibe&width=800&height=500&seq=article-prep-01&orientation=landscape",
    readTime: "7 分钟",
    date: "2026-05-15",
    featured: false,
  },
  {
    slug: "xingjiankang-xinli-jiankang",
    title: "性健康与心理健康：不可分割的关系",
    excerpt: "性健康不仅关乎身体，更与心理健康密切相关。本文探讨焦虑、压力、身体意象等心理因素如何影响女性的性体验和潮喷能力，并提供实用的心理调适策略，帮助你在身心和谐的状态下探索性愉悦。",
    category: "xingjiankang-kepu",
    image: "https://readdy.ai/api/search-image?query=Abstract%20harmonious%20balance%20of%20mind%20and%20body%20illustration%2C%20warm%20coral%20and%20cream%20palette%2C%20soft%20flowing%20shapes%2C%20peaceful%20meditation%20vibe%2C%20minimalist%20art&width=800&height=500&seq=article-mental-01&orientation=landscape",
    readTime: "9 分钟",
    date: "2026-05-10",
    featured: false,
  },
];

export const featuredArticles = allArticles.filter((a) => a.featured);

export const faqs = [
  {
    question: "潮喷和尿失禁是一回事吗？",
    answer: "不是。虽然潮喷液体通过尿道排出，但科学研究表明其成分与尿液有显著差异。潮喷液体含有前列腺特异性抗原（PSA）和酸性磷酸酶等物质，这些是由斯基恩氏腺（女性前列腺）分泌的。当然，由于经过尿道，潮喷液体中可能混合少量尿液，但这与尿失禁是完全不同的生理过程。",
  },
  {
    question: "所有女性都能潮喷吗？",
    answer: "从解剖学角度看，绝大多数女性都具有斯基恩氏腺，理论上具备潮喷的生理基础。但每个人的腺体大小、敏感度和神经分布存在个体差异。潮喷并非衡量性体验质量的唯一标准，无论是否能潮喷，都不影响正常的性快感和高潮体验。",
  },
  {
    question: "自慰会影响以后的性生活吗？",
    answer: "不会。自慰是正常且健康的性行为。研究表明，适度的自慰有助于了解自己的身体偏好，反而有利于提升与伴侣的性生活质量。自慰不会导致'敏感度下降'或'无法从伴侣处获得快感'——这些是常见的误解。",
  },
  {
    question: "如何安全地进行G点刺激？",
    answer: "安全进行G点刺激的关键是：保持手部和工具的清洁卫生；使用足量润滑剂减少摩擦；动作轻柔，从浅到深逐步探索；注意身体反馈，如有疼痛或不适立即停止。G点位于阴道前壁约2-5厘米处，触感略粗糙。用'来'的手势朝腹部方向轻轻按压是常见的刺激手法。",
  },
  {
    question: "潮喷前有什么征兆？",
    answer: "潮喷前的常见征兆包括：强烈的尿意感（即使膀胱已排空）、阴道前壁膨胀感、心跳加速、呼吸急促、盆底肌不自主收缩等。这个'想尿尿'的感觉正是斯基恩氏腺被充分刺激的信号，不必担心会真的失禁，放松身体是这个阶段的关键。",
  },
  {
    question: "自慰频率多少是正常的？",
    answer: "自慰没有统一的'正常'标准。每个人的性欲水平受激素、心理状态、生活压力等多种因素影响，频率从每天多次到每周一次都属于正常范围。关键在于自慰是否影响到了你的日常生活、工作和人际关系。只要不影响正常生活，任何频率都是健康的。",
  },
];